import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HotToastService } from '@ngxpert/hot-toast';
import { AuthService } from '../../../core/auth.service';
import { CommonService } from '../../../services/common.service';
import { SpinnerWhiteComponent } from '../spinner-white/spinner-white.component';
import { ConfirmedValidator } from '../../../models/ConfirmedValidator';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [ReactiveFormsModule, RouterOutlet, FormsModule, CommonModule, SpinnerWhiteComponent, RouterLink],
  templateUrl: './reset-password.component.html',
  styles: ``
})
export class ResetPasswordComponent {

  /*--- Login form ---*/
  loginForm = this.formBuilder.group({
    mail: ['', [Validators.required, Validators.email]],
    userName: ['', [Validators.required, Validators.minLength(3)]]
  })

  /*--- Login form ---*/
  resetPasswordform = this.formBuilder.group({
    NewPassword: ['', [Validators.required, Validators.minLength(8)]],
    ConfirmPassword: ['', [Validators.required]],
  },
    {
      validator: ConfirmedValidator('NewPassword', 'ConfirmPassword')
    })

    passwordValidation = {
      uppercase: false,
      lowercase: false,
      number: false,
      specialChar: false
    };

  spinner: boolean = false

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly toast: HotToastService,
    private readonly route: ActivatedRoute,
    private readonly auth: AuthService,
    private readonly commonService: CommonService
  ) {
    const otpMail = localStorage.getItem('OTPMail')
    const otp = localStorage.getItem('OTP')
    if (otpMail !== null) {
      this.otpSent = true
    }
    if (otp !== null) {
      this.otpVerified = true
    }

  }

  get f(): any { return this.loginForm.controls }
  get g(): any { return this.resetPasswordform.controls }

  resetUser() {
    this.loginForm.controls.mail.reset()
  }

  resetPassword() {
    this.loginForm.controls.userName.reset()
  }

  email: any;
  Otpsentdata: any;
  otpSent: boolean = false
  Otpsent(data: any) {
    this.email = data.mail;
    this.spinner = true
    this.commonService.OtpSend(data).subscribe((data: any) => {
      localStorage.setItem('OTPMail', this.email)
      this.otpSent = true
      this.Otpsentdata = data;
      this.spinner = false
      if (data === true) {
        this.toast.success('OTP sent successfully')
      }
      else if (data === false) {
        this.toast.warning('Something Went Wrong!');
      }
    },
      (error) => {
        this.spinner = false
        this.toast.warning('Something Went Wrong!');
      });
  }

  inputs = ['input1', 'input2', 'input3', 'input4'];

  onKeyUp(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    const code = parseInt(input.value);

    if (code >= 0 && code <= 9) {
      const nextInput = document.getElementById(this.inputs[index + 1]);
      if (nextInput) nextInput.focus();
    } else {
      input.value = '';
    }

    const key = event.key;
    if (key === 'Backspace' || key === 'Delete') {
      const prevInput = document.getElementById(this.inputs[index - 1]);
      if (prevInput) prevInput.focus();
    }
  }

  otpSpin: boolean = false
  otpVerified: boolean = false
  submitOTP() {
    let otp = '';
    this.inputs.forEach(id => {
      const input = document.getElementById(id) as HTMLInputElement;
      otp += input.value;
    });
    const otpMail = localStorage.getItem('OTPMail')
    //console.log('OTP:', otpMail);
    const otpData = {
      otp: parseInt(otp),
      mail: otpMail
    }
    this.otpSpin = true
    this.commonService.otpCheck(otpData).subscribe((data: any) => {
      localStorage.setItem('OTP', '1236')
      this.otpVerified = true
      this.otpSpin = false
      if (data === true) {
        this.toast.success('OTP Validation successfully!');
      }
      else if (data === false) {
        this.toast.warning('Please enter valip Otp!');
      }
    },
      (error) => {
        this.otpSpin = false
        this.toast.warning('Something Went Wrong!');
      });
  }

  text_check: boolean = true;
  text_checks: boolean = true;
  sendEye() {
    this.text_check = !this.text_check;
  }
  sendEyes() {
    this.text_checks = !this.text_checks;
  }

  changePassword: boolean = false
  Resetpassword(data: any) {
    const otpMail = localStorage.getItem('OTPMail')
    let Resetobj = {
      emailID: otpMail,
      newPassword: data.NewPassword,
    }
    this.changePassword = true;
    this.commonService.resetPassword(Resetobj).subscribe((data: any) => {
      this.changePassword = true;
      if (data === true) {
        this.toast.success("Password Updated Successfully.")
        localStorage.clear()
        this.router.navigate(['/login']).then(() => {

        }).catch(error => {
          // Handle the error
        });
      }
      else if (data === false) {
        this.toast.warning('Something Went Wrong!');
      }
    },
      (error) => {
        this.changePassword = true;
        this.toast.warning('Something Went Wrong!');
      });
  }

  checkPasswordValidation() {
    const password = this.resetPasswordform.get('NewPassword')?.value || '';
    this.passwordValidation.uppercase = /[A-Z]/.test(password);
    this.passwordValidation.lowercase = /[a-z]/.test(password);
    this.passwordValidation.number = /\d/.test(password);
    this.passwordValidation.specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  }
  isPasswordFocused: boolean = false;
  onPasswordFocus() {
    this.isPasswordFocused = true;
  }

}
